// tslint:disable
// @ts-nocheck
/**
 * Enter API Documentation
 * ## Interactive Documentation ##### Our API documentation allows you to test API calls straight from this website. ##### To do this, scroll down a little and click the green \"Authorize\" button (with a padlock) to the right and below. A pop-up should appear. ##### In the popup, enter your \"client_id\" and \"client_secret\" values (these will be provided to you) and press \"Authorize\". You should now be logged in (you can open up your network tab to see the API traffic going through). ##### From here, you can click any endpoint below to expand its details and click the \"Try it out\" button that appears in the expanded section. ##### Fill out the parameter fields and then click \"Execute\" to call the endpoint. The results of your query should be shown below. ## Authentication ##### Our API uses the OAuth 2.0 Client Credentials flow to authorize clients. ##### With your provided \"Client Id\" and \"Client Secret\", make the following call: ``` POST /oauth/token HTTP/1.1 Host: api.enter.health  grant_type=client_credentials &client_id=XXXXXXXXXXXX &client_secret=YYYYYYYYYYY ``` ##### Here\'s an example CURL request: ``` curl \'https://api.enter.health/oauth/token\' -H \'accept: application/json\' --data \'grant_type=client_credentials&client_id=XXXXXXXXXXXX&client_secret=YYYYYYYYYYY\' ``` ##### The response should look something like this ``` {   \"access_token\" : \"AAAAAAAAAAAAAAAAAAA\",   \"refresh_token\" : \"BBBBBBBBBBBBBBBBBBB\" }  ``` ##### With the access token provided, you can make an authenticated call to any of the endpoints below by including the header \"Authorization: Bearer AAAAAAAAAAAAAAAAAAA\" with your API request. ##### Here\'s an example of a basic curl request to the \"/me\" endpoint ``` curl \'https://api.enter.health/me\' -H \'accept: application/json\' -H \'authorization: Bearer AAAAAAAAAAAAAAAAAAA\' ``` ##### Note that access tokens are not long-living tokens. The lifetime of them differs from client to client, but they may last as short as 15 minutes (if you would like an increase in time, please reach out to us). ### Comparators ##### Filter parameters need to be formatted with a comparator and value in the format of \"COMPARATOR:VALUE\". The following is a list of possible values:  ##### GTE - Greater than or equal ##### GT - Greater than ##### LT - Less Than ##### LTE - Less than or equal ##### EQ - Equal ##### NQ - Not Equal ##### LK - Like ##### NLK - Not Like ##### EMPTY - Is null ##### NEMPTY - Is not null ## Subject to Change ##### Note that this API is in active development and may be subject to changes at any time. ##### This document is a living document with current specifications. If your integration does not seem to work properly, please refer back to this page to look for updates. ##### If you are still having issues, please reach out to support. 
 *
 * The version of the OpenAPI document: 2
 * Contact: support@enter.health
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import {
    AiPhoneSortType,
    ObjectNoResponse,
    ProviderAIPhone,
    ProviderPhone,
    ProviderPhoneSortType,
    SupportAIPhone,
    SupportAIPhonePayload,
    SupportAssignPhonePayload,
    SupportPhone,
    SupportPhoneSortType,
    SupportAIPhonePayloadToJSON,
    SupportAssignPhonePayloadToJSON,
    ObjectNoResponseFromJSON,
    ProviderAIPhoneFromJSON,
    ProviderPhoneFromJSON,
    SupportAIPhoneFromJSON,
    SupportPhoneFromJSON,
} from '../models';

export interface AssignSupportPhoneRequest {
    id: string;
    supportAssignPhonePayload: SupportAssignPhonePayload;
}

export interface GetProviderAICallRequest {
    id: string;
}

export interface GetProviderAICallsRequest {
    filterId?: Array<string>;
    limit?: number;
    offset?: number;
    order?: Array<GetProviderAICallsOrderEnum>;
    filterCreated?: Array<string>;
    filterClaimId?: Array<string>;
    filterDocumentId?: Array<string>;
    sort?: Array<AiPhoneSortType>;
}

export interface GetProviderPhoneRequest {
    id: string;
}

export interface GetSupportAICallRequest {
    id: string;
}

export interface GetSupportAICallsRequest {
    filterId?: Array<string>;
    limit?: number;
    offset?: number;
    order?: Array<GetSupportAICallsOrderEnum>;
    filterCreated?: Array<string>;
    filterClaimId?: Array<string>;
    filterDocumentId?: Array<string>;
    sort?: Array<AiPhoneSortType>;
}

export interface GetSupportPhoneRequest {
    id: string;
}

export interface ListProviderPhoneRequest {
    filterId?: Array<string>;
    limit?: number;
    offset?: number;
    order?: Array<ListProviderPhoneOrderEnum>;
    filterCreated?: Array<string>;
    filterClaimId?: Array<string>;
    filterDocumentId?: Array<string>;
    filterTranscription?: Array<string>;
    filterMethod?: Array<string>;
    filterChannel?: Array<string>;
    filterPhone?: Array<string>;
    filterAgent?: Array<string>;
    sort?: Array<ProviderPhoneSortType>;
}

export interface ListSupportPhoneRequest {
    filterId?: Array<string>;
    limit?: number;
    offset?: number;
    order?: Array<ListSupportPhoneOrderEnum>;
    filterCreated?: Array<string>;
    filterClaimId?: Array<string>;
    filterDocumentId?: Array<string>;
    filterExternalId?: Array<string>;
    filterAssigned?: Array<string>;
    filterTranscription?: Array<string>;
    filterMethod?: Array<string>;
    filterChannel?: Array<string>;
    filterPhone?: Array<string>;
    filterAgent?: Array<string>;
    filterTag?: Array<string>;
    sort?: Array<SupportPhoneSortType>;
}

export interface PostSupportAiPhoneRequest {
    supportAIPhonePayload: SupportAIPhonePayload;
}

export interface UnassignSupportPhoneRequest {
    id: string;
}

/**
 * no description
 */
export class PhoneApi extends runtime.BaseAPI {

    /**
     * Create and send a phone call
     * Assigns the phone
     */
    async assignSupportPhoneRaw(requestParameters: AssignSupportPhoneRequest): Promise<runtime.ApiResponse<ObjectNoResponse>> {
        if (requestParameters['id'] === null || requestParameters['id'] === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling assignSupportPhone.');
        }

        if (requestParameters['supportAssignPhonePayload'] === null || requestParameters['supportAssignPhonePayload'] === undefined) {
            throw new runtime.RequiredError('supportAssignPhonePayload','Required parameter requestParameters.supportAssignPhonePayload was null or undefined when calling assignSupportPhone.');
        }

        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            if (typeof this.configuration.accessToken === 'function') {
                headerParameters["Authorization"] = this.configuration.accessToken("standard_auth", ["create:phone", "support"]);
            } else {
                headerParameters["Authorization"] = this.configuration.accessToken;
            }
        }

        const response = await this.request({
            path: `/support/phone/{id}/assign`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: SupportAssignPhonePayloadToJSON(requestParameters['supportAssignPhonePayload']),
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => ObjectNoResponseFromJSON(jsonValue));
    }

    /**
     * Create and send a phone call
     * Assigns the phone
     */
    async assignSupportPhone(requestParameters: AssignSupportPhoneRequest): Promise<ObjectNoResponse> {
        const response = await this.assignSupportPhoneRaw(requestParameters);
        return await response.value();
    }

    /**
     * Get a placed AI call
     * Get a placed AI call
     */
    async getProviderAICallRaw(requestParameters: GetProviderAICallRequest): Promise<runtime.ApiResponse<ProviderAIPhone>> {
        if (requestParameters['id'] === null || requestParameters['id'] === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling getProviderAICall.');
        }

        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            if (typeof this.configuration.accessToken === 'function') {
                headerParameters["Authorization"] = this.configuration.accessToken("standard_auth", ["read:phone"]);
            } else {
                headerParameters["Authorization"] = this.configuration.accessToken;
            }
        }

        const response = await this.request({
            path: `/provider/phone/ai/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => ProviderAIPhoneFromJSON(jsonValue));
    }

    /**
     * Get a placed AI call
     * Get a placed AI call
     */
    async getProviderAICall(requestParameters: GetProviderAICallRequest): Promise<ProviderAIPhone> {
        const response = await this.getProviderAICallRaw(requestParameters);
        return await response.value();
    }

    /**
     * Get all placed AI calls
     * Get all placed AI calls
     */
    async getProviderAICallsRaw(requestParameters: GetProviderAICallsRequest): Promise<runtime.ApiResponse<Array<ProviderAIPhone>>> {
        const queryParameters: runtime.HTTPQuery = {};

        if (requestParameters.filterId) {
            queryParameters['filterId'] = requestParameters.filterId;
        }

        if (requestParameters.limit !== undefined) {
            queryParameters['limit'] = requestParameters.limit;
        }

        if (requestParameters.offset !== undefined) {
            queryParameters['offset'] = requestParameters.offset;
        }

        if (requestParameters.order) {
            queryParameters['order'] = requestParameters.order;
        }

        if (requestParameters.filterCreated) {
            queryParameters['filterCreated'] = requestParameters.filterCreated;
        }

        if (requestParameters.filterClaimId) {
            queryParameters['filterClaimId'] = requestParameters.filterClaimId;
        }

        if (requestParameters.filterDocumentId) {
            queryParameters['filterDocumentId'] = requestParameters.filterDocumentId;
        }

        if (requestParameters.sort) {
            queryParameters['sort'] = requestParameters.sort;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            if (typeof this.configuration.accessToken === 'function') {
                headerParameters["Authorization"] = this.configuration.accessToken("standard_auth", ["read:phone"]);
            } else {
                headerParameters["Authorization"] = this.configuration.accessToken;
            }
        }

        const response = await this.request({
            path: `/provider/phone/ai`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(ProviderAIPhoneFromJSON));
    }

    /**
     * Get all placed AI calls
     * Get all placed AI calls
     */
    async getProviderAICalls(requestParameters: GetProviderAICallsRequest): Promise<Array<ProviderAIPhone>> {
        const response = await this.getProviderAICallsRaw(requestParameters);
        return await response.value();
    }

    /**
     * Get a phone call
     * Get a phone call
     */
    async getProviderPhoneRaw(requestParameters: GetProviderPhoneRequest): Promise<runtime.ApiResponse<ProviderPhone>> {
        if (requestParameters['id'] === null || requestParameters['id'] === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling getProviderPhone.');
        }

        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            if (typeof this.configuration.accessToken === 'function') {
                headerParameters["Authorization"] = this.configuration.accessToken("standard_auth", ["read:phone"]);
            } else {
                headerParameters["Authorization"] = this.configuration.accessToken;
            }
        }

        const response = await this.request({
            path: `/provider/phone/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => ProviderPhoneFromJSON(jsonValue));
    }

    /**
     * Get a phone call
     * Get a phone call
     */
    async getProviderPhone(requestParameters: GetProviderPhoneRequest): Promise<ProviderPhone> {
        const response = await this.getProviderPhoneRaw(requestParameters);
        return await response.value();
    }

    /**
     * Get a placed AI call
     * Get a placed AI call
     */
    async getSupportAICallRaw(requestParameters: GetSupportAICallRequest): Promise<runtime.ApiResponse<SupportAIPhone>> {
        if (requestParameters['id'] === null || requestParameters['id'] === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling getSupportAICall.');
        }

        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            if (typeof this.configuration.accessToken === 'function') {
                headerParameters["Authorization"] = this.configuration.accessToken("standard_auth", ["read:phone", "support"]);
            } else {
                headerParameters["Authorization"] = this.configuration.accessToken;
            }
        }

        const response = await this.request({
            path: `/support/phone/ai/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => SupportAIPhoneFromJSON(jsonValue));
    }

    /**
     * Get a placed AI call
     * Get a placed AI call
     */
    async getSupportAICall(requestParameters: GetSupportAICallRequest): Promise<SupportAIPhone> {
        const response = await this.getSupportAICallRaw(requestParameters);
        return await response.value();
    }

    /**
     * Get all placed AI calls
     * Get all placed AI calls
     */
    async getSupportAICallsRaw(requestParameters: GetSupportAICallsRequest): Promise<runtime.ApiResponse<Array<SupportAIPhone>>> {
        const queryParameters: runtime.HTTPQuery = {};

        if (requestParameters.filterId) {
            queryParameters['filterId'] = requestParameters.filterId;
        }

        if (requestParameters.limit !== undefined) {
            queryParameters['limit'] = requestParameters.limit;
        }

        if (requestParameters.offset !== undefined) {
            queryParameters['offset'] = requestParameters.offset;
        }

        if (requestParameters.order) {
            queryParameters['order'] = requestParameters.order;
        }

        if (requestParameters.filterCreated) {
            queryParameters['filterCreated'] = requestParameters.filterCreated;
        }

        if (requestParameters.filterClaimId) {
            queryParameters['filterClaimId'] = requestParameters.filterClaimId;
        }

        if (requestParameters.filterDocumentId) {
            queryParameters['filterDocumentId'] = requestParameters.filterDocumentId;
        }

        if (requestParameters.sort) {
            queryParameters['sort'] = requestParameters.sort;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            if (typeof this.configuration.accessToken === 'function') {
                headerParameters["Authorization"] = this.configuration.accessToken("standard_auth", ["read:phone", "support"]);
            } else {
                headerParameters["Authorization"] = this.configuration.accessToken;
            }
        }

        const response = await this.request({
            path: `/support/phone/ai`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(SupportAIPhoneFromJSON));
    }

    /**
     * Get all placed AI calls
     * Get all placed AI calls
     */
    async getSupportAICalls(requestParameters: GetSupportAICallsRequest): Promise<Array<SupportAIPhone>> {
        const response = await this.getSupportAICallsRaw(requestParameters);
        return await response.value();
    }

    /**
     * Get a phone call
     * Get a phone call
     */
    async getSupportPhoneRaw(requestParameters: GetSupportPhoneRequest): Promise<runtime.ApiResponse<SupportPhone>> {
        if (requestParameters['id'] === null || requestParameters['id'] === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling getSupportPhone.');
        }

        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            if (typeof this.configuration.accessToken === 'function') {
                headerParameters["Authorization"] = this.configuration.accessToken("standard_auth", ["read:phone", "support"]);
            } else {
                headerParameters["Authorization"] = this.configuration.accessToken;
            }
        }

        const response = await this.request({
            path: `/support/phone/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => SupportPhoneFromJSON(jsonValue));
    }

    /**
     * Get a phone call
     * Get a phone call
     */
    async getSupportPhone(requestParameters: GetSupportPhoneRequest): Promise<SupportPhone> {
        const response = await this.getSupportPhoneRaw(requestParameters);
        return await response.value();
    }

    /**
     * Gets a list of phone calls
     * Get a list of phone calls
     */
    async listProviderPhoneRaw(requestParameters: ListProviderPhoneRequest): Promise<runtime.ApiResponse<Array<ProviderPhone>>> {
        const queryParameters: runtime.HTTPQuery = {};

        if (requestParameters.filterId) {
            queryParameters['filterId'] = requestParameters.filterId;
        }

        if (requestParameters.limit !== undefined) {
            queryParameters['limit'] = requestParameters.limit;
        }

        if (requestParameters.offset !== undefined) {
            queryParameters['offset'] = requestParameters.offset;
        }

        if (requestParameters.order) {
            queryParameters['order'] = requestParameters.order;
        }

        if (requestParameters.filterCreated) {
            queryParameters['filterCreated'] = requestParameters.filterCreated;
        }

        if (requestParameters.filterClaimId) {
            queryParameters['filterClaimId'] = requestParameters.filterClaimId;
        }

        if (requestParameters.filterDocumentId) {
            queryParameters['filterDocumentId'] = requestParameters.filterDocumentId;
        }

        if (requestParameters.filterTranscription) {
            queryParameters['filterTranscription'] = requestParameters.filterTranscription;
        }

        if (requestParameters.filterMethod) {
            queryParameters['filterMethod'] = requestParameters.filterMethod;
        }

        if (requestParameters.filterChannel) {
            queryParameters['filterChannel'] = requestParameters.filterChannel;
        }

        if (requestParameters.filterPhone) {
            queryParameters['filterPhone'] = requestParameters.filterPhone;
        }

        if (requestParameters.filterAgent) {
            queryParameters['filterAgent'] = requestParameters.filterAgent;
        }

        if (requestParameters.sort) {
            queryParameters['sort'] = requestParameters.sort;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            if (typeof this.configuration.accessToken === 'function') {
                headerParameters["Authorization"] = this.configuration.accessToken("standard_auth", ["read:phone"]);
            } else {
                headerParameters["Authorization"] = this.configuration.accessToken;
            }
        }

        const response = await this.request({
            path: `/provider/phone`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(ProviderPhoneFromJSON));
    }

    /**
     * Gets a list of phone calls
     * Get a list of phone calls
     */
    async listProviderPhone(requestParameters: ListProviderPhoneRequest): Promise<Array<ProviderPhone>> {
        const response = await this.listProviderPhoneRaw(requestParameters);
        return await response.value();
    }

    /**
     * Gets a list of phone calls
     * Get a list of phone calls
     */
    async listSupportPhoneRaw(requestParameters: ListSupportPhoneRequest): Promise<runtime.ApiResponse<Array<SupportPhone>>> {
        const queryParameters: runtime.HTTPQuery = {};

        if (requestParameters.filterId) {
            queryParameters['filterId'] = requestParameters.filterId;
        }

        if (requestParameters.limit !== undefined) {
            queryParameters['limit'] = requestParameters.limit;
        }

        if (requestParameters.offset !== undefined) {
            queryParameters['offset'] = requestParameters.offset;
        }

        if (requestParameters.order) {
            queryParameters['order'] = requestParameters.order;
        }

        if (requestParameters.filterCreated) {
            queryParameters['filterCreated'] = requestParameters.filterCreated;
        }

        if (requestParameters.filterClaimId) {
            queryParameters['filterClaimId'] = requestParameters.filterClaimId;
        }

        if (requestParameters.filterDocumentId) {
            queryParameters['filterDocumentId'] = requestParameters.filterDocumentId;
        }

        if (requestParameters.filterExternalId) {
            queryParameters['filterExternalId'] = requestParameters.filterExternalId;
        }

        if (requestParameters.filterAssigned) {
            queryParameters['filterAssigned'] = requestParameters.filterAssigned;
        }

        if (requestParameters.filterTranscription) {
            queryParameters['filterTranscription'] = requestParameters.filterTranscription;
        }

        if (requestParameters.filterMethod) {
            queryParameters['filterMethod'] = requestParameters.filterMethod;
        }

        if (requestParameters.filterChannel) {
            queryParameters['filterChannel'] = requestParameters.filterChannel;
        }

        if (requestParameters.filterPhone) {
            queryParameters['filterPhone'] = requestParameters.filterPhone;
        }

        if (requestParameters.filterAgent) {
            queryParameters['filterAgent'] = requestParameters.filterAgent;
        }

        if (requestParameters.filterTag) {
            queryParameters['filterTag'] = requestParameters.filterTag;
        }

        if (requestParameters.sort) {
            queryParameters['sort'] = requestParameters.sort;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            if (typeof this.configuration.accessToken === 'function') {
                headerParameters["Authorization"] = this.configuration.accessToken("standard_auth", ["read:phone", "support"]);
            } else {
                headerParameters["Authorization"] = this.configuration.accessToken;
            }
        }

        const response = await this.request({
            path: `/support/phone`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(SupportPhoneFromJSON));
    }

    /**
     * Gets a list of phone calls
     * Get a list of phone calls
     */
    async listSupportPhone(requestParameters: ListSupportPhoneRequest): Promise<Array<SupportPhone>> {
        const response = await this.listSupportPhoneRaw(requestParameters);
        return await response.value();
    }

    /**
     * Place a scripted AI call on a claim
     */
    async postSupportAiPhoneRaw(requestParameters: PostSupportAiPhoneRequest): Promise<runtime.ApiResponse<SupportAIPhone>> {
        if (requestParameters['supportAIPhonePayload'] === null || requestParameters['supportAIPhonePayload'] === undefined) {
            throw new runtime.RequiredError('supportAIPhonePayload','Required parameter requestParameters.supportAIPhonePayload was null or undefined when calling postSupportAiPhone.');
        }

        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            if (typeof this.configuration.accessToken === 'function') {
                headerParameters["Authorization"] = this.configuration.accessToken("standard_auth", ["create:phone", "support"]);
            } else {
                headerParameters["Authorization"] = this.configuration.accessToken;
            }
        }

        const response = await this.request({
            path: `/support/phone/ai`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: SupportAIPhonePayloadToJSON(requestParameters['supportAIPhonePayload']),
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => SupportAIPhoneFromJSON(jsonValue));
    }

    /**
     * Place a scripted AI call on a claim
     */
    async postSupportAiPhone(requestParameters: PostSupportAiPhoneRequest): Promise<SupportAIPhone> {
        const response = await this.postSupportAiPhoneRaw(requestParameters);
        return await response.value();
    }

    /**
     * Unassigns a phone piece from the user.
     * Unassigns the phone to the granted user
     */
    async unassignSupportPhoneRaw(requestParameters: UnassignSupportPhoneRequest): Promise<runtime.ApiResponse<ObjectNoResponse>> {
        if (requestParameters['id'] === null || requestParameters['id'] === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling unassignSupportPhone.');
        }

        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            if (typeof this.configuration.accessToken === 'function') {
                headerParameters["Authorization"] = this.configuration.accessToken("standard_auth", ["delete:phone", "support"]);
            } else {
                headerParameters["Authorization"] = this.configuration.accessToken;
            }
        }

        const response = await this.request({
            path: `/support/phone/{id}/unassign`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => ObjectNoResponseFromJSON(jsonValue));
    }

    /**
     * Unassigns a phone piece from the user.
     * Unassigns the phone to the granted user
     */
    async unassignSupportPhone(requestParameters: UnassignSupportPhoneRequest): Promise<ObjectNoResponse> {
        const response = await this.unassignSupportPhoneRaw(requestParameters);
        return await response.value();
    }

}

/**
    * @export
    * @enum {string}
    */
export enum GetProviderAICallsOrderEnum {
    ASCENDING = 'ASCENDING',
    DESCENDING = 'DESCENDING'
}
/**
    * @export
    * @enum {string}
    */
export enum GetSupportAICallsOrderEnum {
    ASCENDING = 'ASCENDING',
    DESCENDING = 'DESCENDING'
}
/**
    * @export
    * @enum {string}
    */
export enum ListProviderPhoneOrderEnum {
    ASCENDING = 'ASCENDING',
    DESCENDING = 'DESCENDING'
}
/**
    * @export
    * @enum {string}
    */
export enum ListSupportPhoneOrderEnum {
    ASCENDING = 'ASCENDING',
    DESCENDING = 'DESCENDING'
}
